import React, { Component } from 'react'

import { getCampaignByID } from 'api/campaigns'
import PlaybookCategoryHeader from 'components/PlaybookCategoryHeader'
import getDateRanges from 'components/PlaybookCategoryHeader/DateTimeBuilder'

import EmailReports from './EmailReports'
import { Div } from '@driftt/tide-core'

import '../PlaybookReports/styles.css'

class CampaignReport extends Component {
  constructor(props) {
    super(props)

    const dates = getDateRanges('last_30_days')

    this.state = {
      dateRanges: dates,
      campaign: null,
      campaignLoaded: false,
    }
  }

  componentDidMount() {
    this.getCampaign()
  }

  getCampaign = async () => {
    const { id } = this.props.match.params
    this.setState({ campaignLoaded: false })
    try {
      const { data } = await getCampaignByID(id)
      this.setState({ campaign: data, campaignLoaded: true })
    } catch (error) {
      console.warn(error)
    }
  }

  setDateRanges = (ranges) => {
    const { current, previous } = ranges
    this.setState({
      currentDateRange: current,
      previousDateRange: previous,
      dateRanges: ranges
    })
  }

  render() {
    const { campaign, dateRanges } = this.state
    const reportProps = {
      campaign,
      currentDateRange: dateRanges.current,
      previousDateRange: dateRanges.previous,
    }
    return (
      <Div className="reports-container">
        <Div className="playbook-report-constrain-width">
          <PlaybookCategoryHeader
            changeDates={this.setDateRanges}
            // TODO: fix current_week, previous_month, last_update selections
            campaign={campaign}
          />
          {campaign && <EmailReports {...reportProps}/>}
        </Div>
      </Div>
    )
  }
}

export default CampaignReport
